/**
 * Normalizes a string for search comparison:
 * - Removes diacritics/accents (é → e, ã → a, ç → c)
 * - Converts to lowercase
 * - Trims whitespace
 */
export function normalizeSearch(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Checks if `text` contains `query` using normalized (accent-insensitive, case-insensitive) comparison.
 */
export function matchesSearch(text: string, query: string): boolean {
  if (!query) return true;
  return normalizeSearch(text).includes(normalizeSearch(query));
}
